module.exports = __webpack_public_path__ + "img/sss1.d6e9ad4d.png";